import { getWebApp } from './sdk'
import type { HapticStyle, HapticNotification } from './types'

/**
 * Тактильная отдача. Вне Telegram молча ничего не делает -
 * вызывающий код не должен проверять окружение.
 */

export const haptics = {
  tap(style: HapticStyle = 'light'): void {
    getWebApp().HapticFeedback?.impactOccurred(style)
  },
  notify(type: HapticNotification): void {
    getWebApp().HapticFeedback?.notificationOccurred(type)
  },
  select(): void {
    getWebApp().HapticFeedback?.selectionChanged()
  },
  /** Семантические обёртки - в UI пишем смысл, а не силу вибрации */
  correct(): void {
    this.notify('success')
  },
  wrong(): void {
    this.notify('error')
  },
  cellPress(): void {
    this.tap('light')
  },
  levelUp(): void {
    this.tap('medium')
  },
}
